<template>
 <div style="margin-right: 25px;">
   <b-row>
     <b-col style="height:10vh" class="mb-2">
       <b-row>
         <b-col>
           <div
               style="background-color: #ebc8a9;
                border-radius: 15px;
                 margin: 10px;
                  padding: 10px;
                  width: 200px;
"
           >
             Powered by 💛 Love
           </div>
         </b-col>
         <b-col>
           <b-avatar
               v-if="profile && profile.imgURL"
               :src="profile.imgURL"
           />
           <b-iconstack id="p_settings_control"  :font-scale="2"
                        style="cursor:pointer; margin: 5px">
             <b-icon stacked icon="circle-fill"
                     variant="dark"/>
             <b-icon stacked icon="gear"
                     variant="light"
                     scale="0.5"
                     shift-v="-0.25"
                     rotate="130"
             />
           </b-iconstack>
         </b-col>
       </b-row>
     </b-col>
   </b-row>
   <b-row>
     <b-col cols="12"
            style="background-color: #F4F4F4FF;
            height: 70vh;
            margin-left: 5px;
            scroll-margin-right: 15px;
            border-radius: 25px"
     >
       <div>
         <b-tabs
             :pills="tabs.isPills"
             :small="tabs.isSmall"
             :justified="tabs.isJustified"
             :isFill="tabs.isFill"
             :end="tabs.isEnd"
             :vertical="tabs.isVertical"
             content-class="mt-3"
             defaultActiveKey="stage"
         >
           <b-tab
               v-for="(aSection, index) in availSections"
               :key="index"
               :title="aSection.title"
           >
             <template #title>
               <h6 style="padding-top: 25px;">
                 <b-icon
                     v-if="aSection.icon"
                     :icon="aSection.icon"
                     aria-hidden="true"
                 />
                 {{ aSection.title }}
               </h6>
             </template>
             <component
                 :is="aSection.component"
                 v-bind="Object.assign({}, propsData)"
                 :ref="aSection.componentName"
             />
           </b-tab>
         </b-tabs>
       </div>
     </b-col>
   </b-row>
 </div>
</template>

<script>
import { mapGetters } from "vuex";
import SessionChat from "./chat";
import SessionQA from "./qa";
import SessionResources from "./resources";
import SessionPoll from "./poll";
export default {
  name: "Sessions_Sidebar_Session_Body",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({}),
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        session: this.session
      };
    }
  },
  methods: {},
  data() {
    return {
      mainPropsLogo: { blank: false, blankColor: '#777', class: 'm1' },
      showLogo: true,
      screen: {
        bgColor: "#222222"
      },
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: false
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections : [
        {
          title: "Chat",
          id: "chat",
          component: SessionChat,
          componentName: "SessionChat",
          avail: true
        },
        {
          title: "Q&A",
          id: "qa",
          component: SessionQA,
          componentName: "SessionQA",
          avail: true
        },
        {
          title: "Resources",
          id: "resources",
          component: SessionResources,
          componentName: "SessionResources",
          avail: true
        },
        {
          title: "Poll",
          id: "poll",
          component: SessionPoll,
          componentName: "SessionPoll",
          avail: true
        }
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
.bottom {
  align-self: flex-end;
}

.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
